import {Input} from '../../../index';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import React from 'react';

export const FormikInput = props => {
  const { className, wrapperClassName = 'col-sm', name, label, Component = Input, setFormat, ...other } = props;

  return (<div className={wrapperClassName}>
    <Field name={name}>
      {({ field, form: { handleChange, handleBlur }, meta }) => {
        return <Component
            className={className}
            label={label}
            name={field.name}
            value={meta.value}
            error={(meta.touched && meta.error) && meta.error}
            onChange={handleChange}
            onBlur={e => {
              if(typeof setFormat === 'function') setFormat(meta.value, e);
              return handleBlur(e)
            }}
            {...other}
          />
      }}
    </Field>
  </div>);
};

FormikInput.propTypes = {
  wrapperClassName: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default React.memo(FormikInput);
